import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/',
            name: 'login',
            component: () => import("./views/login.vue")
        },
        {
            path: '/admin',
            name: 'login admin',
            component: () => import("./views/loginAdmin.vue")
        }
    ];
};